module.exports = __webpack_public_path__ + "static/media/computer.2cddf86f.svg";